import { render, staticRenderFns } from "./MobileScreenFooterBox.vue?vue&type=template&id=5bfa21f2&"
import script from "./MobileScreenFooterBox.vue?vue&type=script&lang=js&"
export * from "./MobileScreenFooterBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports